(function () {
  'use strict';

  var DESKTOP_BREAKPOINT = '(min-width: 990px)';

  function initAccordion(section) {
    var toggles = section.querySelectorAll('.oddit-footer__column-toggle');
    if (!toggles.length) return;

    var mql = window.matchMedia(DESKTOP_BREAKPOINT);

    function handleToggleClick(e) {
      if (mql.matches) return; // accordion disabled on desktop
      var btn = e.currentTarget;
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    }

    for (var i = 0; i < toggles.length; i++) {
      toggles[i].addEventListener('click', handleToggleClick);
    }

    function syncBreakpoint() {
      // On desktop, force all panels visible (aria-expanded irrelevant since toggle is non-interactive)
      // On mobile, default everything to collapsed
      for (var j = 0; j < toggles.length; j++) {
        if (mql.matches) {
          toggles[j].setAttribute('aria-expanded', 'true');
        } else {
          toggles[j].setAttribute('aria-expanded', 'false');
        }
      }
    }

    if (mql.addEventListener) {
      mql.addEventListener('change', syncBreakpoint);
    } else if (mql.addListener) {
      mql.addListener(syncBreakpoint);
    }

    syncBreakpoint();
  }

  function initSection(section) {
    if (!section || section.dataset.odditFooterInit === 'true') return;
    section.dataset.odditFooterInit = 'true';
    initAccordion(section);
  }

  function bootstrap() {
    var sections = document.querySelectorAll('.oddit-footer');
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.oddit-footer');
    if (section) initSection(section);
  });
})();
